export enum DrawerBoxUpgradeCost {
    NONE = 0,
    DOVETAILS = 40
}
